import { render, staticRenderFns } from "./AmountNewController.vue?vue&type=template&id=d880f0c6&scoped=true&"
import script from "./AmountNewController.vue?vue&type=script&lang=js&"
export * from "./AmountNewController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d880f0c6",
  null
  
)

export default component.exports